import React, { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { Typography } from '@components/atoms/typography';
import type { LoadingFilesProps } from '@components/organisms/files-uploader/loading-files/types';
import { useAppTheme } from '@theme';
import { replaceColor } from 'lottie-colorify';
import Lottie from 'lottie-react';

import { lightTheme } from '../../../../theme';

import loadingAnimation from './loading-animation.json';
import { LoadingBox } from './styles';

export const LoadingFiles: React.FC<LoadingFilesProps> = ({ className }) => {
    const { t } = useTranslation();
    const theme = useAppTheme();
    const animationData = useMemo(() => {
        let animation = loadingAnimation;

        animation = replaceColor(lightTheme.palette.primaryA1, theme.palette.primaryA1, animation);
        animation = replaceColor('#c4c4fc', theme.palette.primaryA3, animation);
        animation = replaceColor(lightTheme.palette.primaryA6, theme.palette.primaryA6, animation);

        return animation;
    }, [theme]);

    return (
        <LoadingBox className={className}>
            <Lottie animationData={animationData} loop={true} className='loading-icon' />
            <Typography variant='text-bold' tag='p' className='loading-title'>
                {t('docVerificationWidget.loadingFile.text-1')}
            </Typography>
            <Typography
                variant='small-text'
                tag='p'
                color='text-light'
                className='loading-description'
            >
                {t('docVerificationWidget.loadingFile.text-2')}
            </Typography>
        </LoadingBox>
    );
};
